/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Box, Grid, GridProps, Text,
} from '@chakra-ui/react';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    LuBookOpen, LuCakeSlice, LuTruck, LuMartini, LuChefHat, LuShoppingCart,
} from 'react-icons/lu';
import { IconType } from 'react-icons';
import { useCart } from 'features';

type ToolbarNavItemProps = {
    to: string
    label: string
    badgeCount?: number
    icon: IconType
} & GridProps

const ToolbarNavItem: React.FC<ToolbarNavItemProps> = ({
    to,
    label,
    badgeCount,
    icon,
    ...restProps
}) => {
    const navigate = useNavigate();

    const { pathname } = useLocation();

    let isActive = false;

    if (pathname.startsWith(to)) {
        isActive = true;
    }

    return (
        <Grid {...restProps} onClick={() => navigate(to)}>
            <Grid templateRows="3fr 2fr" padding="0.5rem" gap="1rem">
                <Grid margin="auto" position="relative">
                    {badgeCount && (
                        <Box
                            position="absolute"
                            right="-20%"
                            top="-20%"
                            padding="0.05rem 0.25rem"
                            background="#E74C3C"
                        >
                            <Text color="white" fontWeight={900} textAlign="center">
                                {badgeCount}
                            </Text>
                        </Box>
                    )}
                    {icon({ size: '2.25rem', color: isActive ? '#E74C3C' : 'black' })}
                </Grid>
                <Text textAlign="center" width="100%" color={isActive ? '#E74C3C' : 'black'} lineHeight="1" fontWeight={isActive ? 'bold' : 'regular'} fontSize="1rem">
                    {label}
                </Text>
            </Grid>
        </Grid>
    );
};

type ToolbarProps = GridProps

export const Toolbar: React.FC<ToolbarProps> = () => {
    const { totalCount } = useCart();

    return (
        <Grid background="white">
            <Box height="1px" background="#DDDDDD" />
            <Grid
                templateColumns="repeat(6, 1fr)"
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                margin="0 auto"
                padding="0.5rem 2rem"
            >
                <ToolbarNavItem to="/catering" label="Кейтеринг" icon={LuBookOpen} />
                <ToolbarNavItem to="/delivery" label="Доставка" icon={LuTruck} />
                <ToolbarNavItem to="/culinary-studio" label="Кулинарная студия" icon={LuChefHat} />
                <ToolbarNavItem to="/outdoor-bars" label="Выездные бары" icon={LuMartini} />
                <ToolbarNavItem to="/sweet-shop" label="Кондитерская" icon={LuCakeSlice} />
                <ToolbarNavItem to="/cart" label="Корзина" icon={LuShoppingCart} badgeCount={totalCount > 0 ? totalCount : undefined} />
            </Grid>
        </Grid>
    );
};
